import { Anomaly } from '@api/twin/AnomalyApi';
import { createContext, useContext, useMemo } from 'react';
import { useAnomaly } from '../hooks/useAnomaly';
import { useAnomalyWidgetContext } from './AnomalyWidgetContext';

interface AnomalySectionContext {
  anomaly: Anomaly;
}

const Context = createContext<AnomalySectionContext | null>(null);

export interface TabContainerProps {
  children?: React.ReactNode;
  anomaly: Anomaly;
}

export const AnomalySectionProvider = (props: TabContainerProps) => {
  const { anomaly, children } = props;
  const { projectId } = useAnomalyWidgetContext();
  const { data, isLoading } = useAnomaly(projectId, anomaly.id);

  const ctx = useMemo(
    () => ({
      anomaly: (data && !isLoading) ? data : anomaly,
    }),
    [anomaly, data, isLoading],
  );

  return <Context.Provider value={ctx}>{children}</Context.Provider>;
};

export const useAnomalySectionContext = () => {
  const ctx = useContext(Context);

  if (!ctx) {
    throw new Error('Anomaly Section Context not found');
  }

  return ctx;
};
